import { createModuleI18nNamespaces } from "src/system/createModuleI18nNamespaces.ts";
import type { NamespaceTester } from "src/lib/i18next/types.ts";
import { getAllModulesIds } from "src/system/getAllModulesIds.ts";
import { ResourceEnum } from "src/constants/constants.ts";

const resources = (
  Object.keys(ResourceEnum) as Array<keyof typeof ResourceEnum>
).map((key) => ResourceEnum[key]);

const isResourceFormNs = (ns: string) => (resource: string) => {
  const namespace = createModuleI18nNamespaces();

  return (
    namespace.form({ type: "create", resource }) === ns ||
    namespace.form({ type: "edit", resource }) === ns
  );
};

export const resourceForm: NamespaceTester = (ns: string, lang: string) => {
  const resource = resources.find(isResourceFormNs(ns));

  if (resource) {
    const modules = getAllModulesIds();
    const forms = import.meta.glob(
      "../../../admin/modules/*/forms/**/locales/*.json",
    );
    for (let i = 0; i < modules.length; i++) {
      const moduleId = modules[i];
      const relatePath = `../../../admin/modules/${moduleId}/forms/${resource}/locales/${lang}.json`;

      if (forms[relatePath]) {
        return `src/admin/modules/${moduleId}/forms/${resource}/locales/${lang}.json`;
      }
    }
    throw new Error("cannot load form translations");
  }
};
